import {TableColumnConfig} from '../../table';
import {TableColumnReorderColumnMeta} from './table-column-reorder-column-meta';

export class TableColumnReorderColumnsArea {

    public static getAreasByColumns(columns: TableColumnReorderColumnMeta[]): TableColumnReorderColumnsArea[] {
        return columns.reduce((iterationMeta, columnMeta) => {
            const groupId = columnMeta.columnDef.groupId;
            const isGroupedColumn: boolean = groupId !== null && groupId !== undefined;
            let columnsGroup: TableColumnReorderColumnMeta[];

            if (isGroupedColumn) {
                columnsGroup = iterationMeta.columnGroupsMapById.get(groupId);

                if (columnsGroup) {
                    columnsGroup.push(columnMeta);
                }
            }

            if (!columnsGroup) {
                columnsGroup = [columnMeta];

                iterationMeta.columnGroups.push(columnsGroup);

                if (isGroupedColumn) {
                    iterationMeta.columnGroupsMapById.set(groupId, columnsGroup);
                }
            }

            return iterationMeta;
        }, {
            columnsLeft: columns.slice(),
            columnGroupsMapById: new Map(),
            columnGroups: []
        } as {
            columnsLeft: TableColumnReorderColumnMeta[];
            columnGroupsMapById: Map<any, TableColumnReorderColumnMeta[]>;
            columnGroups: TableColumnReorderColumnMeta[][]
        }).columnGroups
            .map(columnsGroup => new TableColumnReorderColumnsArea(columnsGroup));
    }

    public static mapAreasToColumnsMeta(areas: TableColumnReorderColumnsArea[]): TableColumnReorderColumnMeta[] {
        return areas.reduce((columnsConfig, columnsArea) => {
            columnsConfig.push(...columnsArea.columns);

            return columnsConfig;
        }, []);
    }

    public static mapAreasToConfigs(areas: TableColumnReorderColumnsArea[]): TableColumnConfig[] {
        return areas.reduce((columnsConfig, columnsArea) => {
            columnsConfig.push(...columnsArea.getColumnsConfig());

            return columnsConfig;
        }, []);
    }

    public columns: TableColumnReorderColumnMeta[];
    public rect: ClientRect;

    constructor(
        columns: TableColumnReorderColumnMeta[]
    ) {
        this.columns = columns;
        this.updateRect();
    }

    public updateRect(): void {
        interface SimpleRect {
            left?: number;
            right?: number;
            top?: number;
            bottom?: number;
        }

        const simpleRect: SimpleRect = this.columns.reduce((rect: SimpleRect, columnMeta) => {
            const {left, right, top, bottom} = columnMeta.element.getBoundingClientRect();

            if (rect) {
                rect.left   = Math.min(rect.left, left);
                rect.right  = Math.max(rect.right, right);
                rect.top    = Math.min(rect.top, top);
                rect.bottom = Math.max(rect.bottom, bottom);
            } else {
                rect = {left, right, top, bottom};
            }

            return rect;
        }, null);

        this.rect = new DOMRect(
            simpleRect.left,
            simpleRect.top,
            simpleRect.right - simpleRect.left,
            simpleRect.bottom - simpleRect.top
        );
    }

    public getColumnsConfig(): TableColumnConfig[] {
        return this.columns.map(columnMeta => columnMeta.columnConfig);
    }

}
